import FirestoreDataClass from "./_baseClasses";

export default class ReportEmailSubscription extends FirestoreDataClass {
  static collectionName = "report_email_subscriptions";
  static allCategories = ["efficiency", "hygiene", "leaks", "system"];
}
